/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/
import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { KnowledgeBaseDetailService } from '../../../selfhelp/knowledgebasecontainer/knowledgebasedetail/knowledgebasedetail.service';
import { Router } from '@angular/router';
import { KnowledgeBaseDetailInfo } from '../../../selfhelp/knowledgebasecontainer/knowledgebasedetail/knowledgebasedetailinfo';
import { HttpRequest, HttpEvent, HttpEventType, HttpClient } from '@angular/common/http';
import { CommonConstants } from './../../../../../common/constants/common-constants';
import * as FileSaver from 'file-saver';
import { RateInfoResponse } from '../../../selfhelp/model/rateresponse';
import { KbaAttachment } from '../../../selfhelp/model/kbaattachmentresponse';
import { BehaviorSubject } from 'rxjs';
import { ProposedSolutionService } from '../service/proposedsolution.service';
declare var $: any;

@Component({
  selector: 'zsd-proposedsolutiondetail',
  templateUrl: '../view/proposedsolutiondetail.component.html',
  styleUrls: ['../view/proposedsolutiondetail.component.scss']
})
export class ProposedSolutionDetailComponent implements OnInit, OnChanges {

readonly ARTICLE_INDEX = 1000;
readonly FAQ_INDEX = 2000;
readonly SOLUTION_INDEX = 4000;

knowledgebaseDetail: KnowledgeBaseDetailInfo = new KnowledgeBaseDetailInfo();
isArticle: boolean;
isFAQ: boolean;
isSolution: boolean;
isItemTypes: boolean;
isItems: boolean;
_kbaNo: BehaviorSubject<number> = new BehaviorSubject<number>(null);
kbaNumber: number;
kbaAttachmentResponse: any;
hasAttachment: boolean;
attachmentIsLoading = false;
@Input() requestId: number;

@Input() set kbaId(value: number) {
    this._kbaNo.next(value);
}
get kbaId() {
   return this._kbaNo.getValue();
}

constructor(private knowledgebasedetailservice: KnowledgeBaseDetailService,
    private http: HttpClient, public router: Router ,
    private proposedSolutionService: ProposedSolutionService) {

}

ngOnChanges(changes: SimpleChanges): void {
    this.knowledgebaseDetail = new KnowledgeBaseDetailInfo();
    this.kbaNumber = changes.kbaId.currentValue;
    this.getKnowledgebaseDetail(this.kbaNumber);
}

ngOnInit() {
  this.knowledgebaseDetail = new KnowledgeBaseDetailInfo();
  this.getKnowledgebaseDetail(this.kbaId);
  $('html, body').animate({
    scrollTop: $('#proposedsolution_detail').offset().top - 100}, 'slow' );
}

getKnowledgebaseDetail(kbaId: number): void {
    let knowledgebaseDetailService = this.knowledgebasedetailservice;
    this.knowledgebasedetailservice.getKnowledgeBaseDetail(kbaId).subscribe(
        (knowledgebaseDetail: KnowledgeBaseDetailInfo) => {
            this.knowledgebaseDetail = knowledgebaseDetail;
            switch (knowledgebaseDetail.kbaBasicInfo.kbaTypeIndex) {
                case this.ARTICLE_INDEX:
                    this.isArticle = true;
                    break;
                case this.FAQ_INDEX:
                    this.isFAQ = true;
                    break;
                case this.SOLUTION_INDEX:
                    this.isSolution = true;
                    break;
            }
            if (knowledgebaseDetail.item && knowledgebaseDetail.item.length > 0) {
                this.isItems = true;
            }
            if (knowledgebaseDetail.itemType && knowledgebaseDetail.itemType.length > 0) {
                this.isItemTypes = true;
            }

            $(function () {
                $('#rateAvg').rateYo({
                    starWidth: '16px',
                    rating: knowledgebaseDetail.kbaBasicInfo.averageRating,
                    ratedFill: '#15DB66',
                    normalFill: '#D4D6DA',
                    readOnly: true
                });
            });
            $(function () {
                $('#rateUser').rateYo({
                    starWidth: '16px',
                    rating: knowledgebaseDetail.rating,
                    ratedFill: '#15DB66',
                    normalFill: '#D4D6DA',
                    fullStar: true,
                    onSet: (rating, rateYoInstance) => {
                        rateYoInstance = rateYoInstance;
                        knowledgebaseDetailService.rateKba(knowledgebaseDetail.kbaBasicInfo.kbaId, rating).subscribe(
                            (rateInfoResponse: RateInfoResponse) => {
                                // update averate ratig and vote count after user rates any knowledgebase
                                $('#rateAvg').rateYo('option', 'rating', rateInfoResponse.updatedAvgRating);
                                knowledgebaseDetail.voteCount = rateInfoResponse.updatedVoteCount;
                            }
                        );
                    }
                });
            });
        },
        err => {
            console.error(err);
        }
    );

}
getAttachment() {
          this.knowledgebasedetailservice.getAttachmentDetails(this.kbaId).subscribe((kbaAttachment: any) => {
            this.kbaAttachmentResponse = kbaAttachment;
        });
    }


attachmentDetails(kbaAttachment: KbaAttachment) {
    let attachmentParentType = 'KbaAttachment';
    this.attachmentIsLoading = true;
    this.downloadAttachment(kbaAttachment.attachmentId, attachmentParentType, this.knowledgebaseDetail.kbaBasicInfo.kbaId);
}

downloadAttachment(attachmentId: number, attachmentParentType: String, parentEntityId: number) {
    const downloadRequest = new HttpRequest('GET', CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/download/' + attachmentId +
        '?attachmentParentType=' + attachmentParentType + '&parentEntityId=' + parentEntityId, {
            responseType: 'blob'
        });
    this.http.request(downloadRequest).subscribe(
        (event: HttpEvent<any>) => {
            if (event) {
                switch (event.type) {
                    case HttpEventType.ResponseHeader:
                        let contentDispositionHeader = event.headers.get('Content-Disposition');
                        contentDispositionHeader = contentDispositionHeader.substr(22, (contentDispositionHeader.length - 1));
                        console.log(contentDispositionHeader); // Always null here although I expected it to be there.
                        break;

                    case HttpEventType.Response:
                        let contentDispositionHeader2 = event.headers.get('Content-Disposition');
                        contentDispositionHeader2 = contentDispositionHeader2.substr(22, (contentDispositionHeader2.length - 23));
                        const downloadedFile: Blob = event.body;
                        this.attachmentIsLoading = false;
                        FileSaver.saveAs(downloadedFile, contentDispositionHeader2);
                        break;
                }
            }
        },
        err => console.log(err.error)
    );
}
 resolveRequest() {
    this.proposedSolutionService.resolveRequestThroughProposedSolution(this.requestId, this.kbaNumber ).subscribe(
        () => {
    this.router.navigate([CommonConstants.REQUEST_COMPONENT]);
  }),
  err => {
      console.log(err);
  };
}
}
